const DismissibleActionConstants = {
  SCHEDULING_ROLLOUT_LANDLORD: 'schedulingRolloutLandlord',
  PAYMENT_PLAN_INSTRUCTIONS: 'paymentPlanInstructions',
};

export default DismissibleActionConstants;
